var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51432 3.76459C5.47948 3.79955 5.43809 3.82729 5.3925 3.84622C5.34692 3.86515 5.29805 3.87489 5.2487 3.87489C5.19934 3.87489 5.15047 3.86515 5.10489 3.84622C5.05931 3.82729 5.01791 3.79955 4.98307 3.76459L3.37401 2.15553L3.37401 6.74928C3.37401 6.84874 3.3345 6.94412 3.26417 7.01444C3.19385 7.08477 3.09847 7.12428 2.99901 7.12428C2.89955 7.12428 2.80417 7.08477 2.73384 7.01444C2.66352 6.94412 2.62401 6.84874 2.62401 6.74928L2.62401 2.15553L1.01432 3.76459C0.943874 3.83504 0.848326 3.87462 0.748697 3.87462C0.649069 3.87462 0.553521 3.83504 0.483072 3.76459C0.412624 3.69414 0.373047 3.5986 0.373047 3.49897C0.373047 3.39934 0.412624 3.30379 0.483072 3.23334L2.73307 0.983343C2.76791 0.948383 2.80931 0.920644 2.85489 0.901717C2.90047 0.88279 2.94934 0.873047 2.9987 0.873047C3.04805 0.873047 3.09692 0.88279 3.1425 0.901717C3.18809 0.920644 3.22948 0.948383 3.26432 0.983343L5.51432 3.23334C5.54928 3.26818 5.57702 3.30958 5.59595 3.35516C5.61488 3.40074 5.62462 3.44961 5.62462 3.49897C5.62462 3.54832 5.61488 3.59719 5.59595 3.64277C5.57702 3.68836 5.54928 3.72975 5.51432 3.76459Z",
    fill: "#B60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.05a68a4c383e158636cae634d17d7e7a.svg";
export { ForwardRef as ReactComponent };